import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import CheckoutSettings from './settings/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ecommerce/checkout'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'checkout_settings_index',
            params: to.params,
          }),
        },
        {
          path: 'settings',
          name: 'checkout_settings_index',
          meta: { permissions: ['administrator'] },
          component: CheckoutSettings,
        },
      ],
    },
  ],
};
